import { Grid, Stack, Skeleton } from '@mui/material'
import React from 'react'

function TemplateFormContentSkeleton() {
  return (
    <>
      <Stack component="div" padding={2} flexDirection="column" width="75%">
        <Grid container height={150} mb={2}>
          <Skeleton height="100%" width="100%" />
        </Grid>
        <Grid container height={250} mb={2}>
          <Skeleton height="100%" width="100%" />
        </Grid>
        <Grid container height={120}>
          <Skeleton height="100%" width="100%" />
        </Grid>
      </Stack>
      <Stack
        component="div"
        bgcolor="#E5E5E5"
        width="25%"
        display="flex"
        justifyContent="flex-start"
        alignItems="initial"
        borderRadius={1}
      />
    </>
  )
}

export default TemplateFormContentSkeleton
